import { Loading } from "@/components/common/Loading";
import { Protected } from "@/components/layout/Protected"
import { ContractService } from "@/service/services/Contract.service";
import { KEY_USER_DATA } from "@/toolbox/constants/local-storage";
import { ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_TRABAJADOR } from "@/toolbox/defaults/static-roles";
import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { Alert, Button, Grid, Snackbar, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ROUTE_CUSTOMIZE_CONTRACT, ROUTE_WORKER, ROUTE_MY_REQUEST, ROUTE_PROFILES } from "@/toolbox/constants/route-map";
import { ModalContractValidation } from "@/components/Modal/ModalContractValidation";
import { ModalSignatureDetail } from "@/components/Modal/ModalSignatureDetail/ModalSIgnatureDetail";

export const ContractEmployee: React.FC<any> = (props: any) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [dataPDF, setDataPDF] = useState<any>(null)
    const [messageStatus, setMessageStatus] = useState<any>('');
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openModalDetail, setOpenModalDetail] = useState<boolean>(false);

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
    const userData = readLocalStorage(KEY_USER_DATA);
    const idEmployee = props?.location?.state?.idEmployee || userData?.user.idemployee;
    const role = userData?.user.role
    const nameEmployee = props?.location?.state?.name

    const history = useHistory();

    const getContract = async () => {
        setLoading(true);
        const RespPDF = await ContractService.getDocumentContract(idEmployee)
        if (RespPDF) {

            const blob = new Blob([RespPDF], { type: 'application/pdf' });
            const blobURL = URL.createObjectURL(blob);
            setDataPDF(blobURL)
        }
        setLoading(false);
    }

    const getContractStatus = async() =>{
        const respStatus = await ContractService.getValidationSignature();
        if(respStatus?.data){
            setMessageStatus(respStatus?.data?.message)
        }
    }

    const createSignature = async(data) => {
        const respStatus = await ContractService.createSignature(data);
        getContract();
        getContractStatus();
        return respStatus
    }

    const showViewEditContract = () => {
        // window.open(`${ROUTE_CUSTOMIZE_CONTRACT}`, '_target');
        history.push(ROUTE_CUSTOMIZE_CONTRACT, {idEmployee: idEmployee})
    }


    useEffect(() => {
        getContract();
        getContractStatus();
    }, [])

    return (
        <Protected>
            {loading && <Loading />}
            <Snackbar
                open={snackBarConfig.open}
                autoHideDuration={snackBarConfig.autoHideDuration}
                onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
                <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                    {snackBarConfig.message || ""}
                </Alert>
            </Snackbar>
            <Container>

                {role == ROLE_TRABAJADOR &&<> <Typography variant='h6' component='h1' gutterBottom className="tittle-level2"
                    sx={{ m: 1, fontWeight: 600 }}
                >
                    Mi contrato
                </Typography>
                <Grid my={2}>
                <span>{`Estado del contrato : ${messageStatus}`}</span>
                </Grid>
                </>
                }
               
              
                {role == ROLE_ADMIN &&
                    <>
                        <Link to={ROUTE_WORKER} className='link__css'>
                            <Typography variant='h6' gutterBottom className='link__css-back'>
                                <ArrowBackIosIcon className='icon_back' /> Volver
                            </Typography>
                        </Link>
                        <Typography variant='h6' component='h1' gutterBottom className="tittle-level2"
                            sx={{ m: 1, fontWeight: 600 }}
                        >
                            {nameEmployee}
                        </Typography>
                    </>
                }
                {/* { dataPDF &&  <Button onClick={()=>{setOpenModal(true)}}>Solicitar Revisión</Button>} */}
                {
                    dataPDF && role == ROLE_TRABAJADOR && (
                        messageStatus == 'Falta subir datos de su firma' || messageStatus == 'Verificación rechazada'
                    ) && <Button sx={{ my: 2 }} onClick={() => { setOpenModal(true) }}>Firmar</Button>
                }
                { dataPDF && role == ROLE_ADMIN && (
                        <Grid sx={{justifyContent: 'space'}}>
                            <Button sx={{ my: 2 }} onClick={() => {setOpenModalDetail(true) }}>Ver Firma </Button>
                            {/* <Button sx={{ my: 2, justifyContent:'end' }} onClick={() => {showViewEditContract() }}>Editar Contrato</Button> */}
                            
                        </Grid>
                    )
                }

                <iframe src={dataPDF} id="pdfVer" height="1000px" width="100%"></iframe>
            </Container>

            {
                openModal && <ModalContractValidation
                open={openModal}
                setOpen={setOpenModal}
                createSignature={createSignature}
                />
            }
            {
                openModalDetail && <ModalSignatureDetail
                open={openModalDetail}
                setOpen={setOpenModalDetail}
                idEmployee={idEmployee}
                getContractStatus={getContractStatus}
                getContract={getContract}
                />
            }

        </Protected>
    )
}